import { getPersonalDetailsSummary, getPurchasePersonalDetailsForm } from "../../../selectors/kaMetlhaFuneralCover/personalDetails";
import { getLeadMailPayload } from "../../../selectors/kaMetlhaFuneralCover/quote";
import axios from 'axios';

export const leadsMailService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        const productLabel='Ka-Metlha-Funeral'
        const leadsPayload= getLeadMailPayload(state)
        // const {fullName,cellphoneNumber,email}=personalDetail
        // const name=action.value==='purchaseMail' ? purchasePersonalDetails.fullname : fullName
        

        const sampleRequestBody = {
            firstName:" ",
            lastName:" ",
            contactNumber:" ",
            subject:`Web: ${productLabel}${" "}`,
            userDataFields: leadsPayload,
            templateType:"ALLSURE_QUOTE_CUSTOMER",
            monthlyPremium:  null,
            yearlyPremium: null,
            referenceNumber: null,
            email: "BW_KMF_BUSSINESS_MAIL"
        }
        const quoteData = await sendEmailNotification(sampleRequestBody);
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        return error;
    }
};










